
export const environment = {
    production: false,
    pwa_host: "https://uat-afl.marshsport.com.au",
    api_url: "https://uat.dip.services.marsh.com/api/route",
    tokenGenKey: "d1U3eSsrN0MyNVk2Vk1kWGdiOHppUT09OkJNa0FWWE1XZXUxcDNuaG5wdkh3cEY2bm1mbW1qUm9VYjVlbGVhUTRXNVU9OkRzZUtZL0VmYlJSQUpwTkJ3SUowcXJnR1ZGS2RZZnVHa3QvM0x6S0pkdGljUWJTSy83eXpKS0gyeDRqUFhFQ0RQa0NoSENvVw==",
    schemeCode : 'AFLAPP',
    applicationName : 'Marsh AFL',
    applicationVersion : '1.0.4.25',
    reCaptchaSiteKey: '6LfA8fIqAAAAAI9wc3KZXvXXM4O49eSGeE12A0j6',
    csp: {
      'default-src': "'self'",
      'script-src': "'self'", // No unsafe-eval in UAT
      'style-src': "'self' 'unsafe-inline'", // Angular requires unsafe-inline for component styles
      'img-src': "'self' data: blob:",
      'font-src': "'self' data:",
      'connect-src': "'self' https://uat.dip.services.marsh.com https://www.google.com https://www.gstatic.com",
      'media-src': "'self'",
      'object-src': "'none'",
      'child-src': "'self'",
      'frame-src': "'self' https://www.google.com https://recaptcha.google.com",
      'worker-src': "'self'",
      'manifest-src': "'self'",
      'form-action': "'self'",
      'frame-ancestors': "'none'",
      'base-uri': "'self'"
    }
  };
  